import "./product.css"
import { useState } from "react"
import PageAdress from "../../components/pageAdress/pageAdress"
import Filter from "../../components/filter/filter"
import Product from "../../components/product/products"



function Products(){
    return(
        <div className="products">
            <div className="products-container">
                <PageAdress data={"محصولات"} data2={""} data3={""}/>
                <Filter/>
                <Product/>
            </div>
        </div>
    )
}

export default Products;